<template>
  <PageWithLoading :ready="$page !== null">
    <SectionsRenderer :sections="$page.sections"/>
  </PageWithLoading>
</template>

<script>
import PageWithLoading from '@/components/templates/PageWithLoading.vue'
import SectionsRenderer from '@/components/SectionsRenderer.vue'
import {PageMetaMixin} from '@/mixins'

export default {
  name: 'Home',
  beetPage: 'home',
  mixins: [PageMetaMixin],
  components: {PageWithLoading, SectionsRenderer},
}
</script>
